import React from 'react'
import styles from './ScrollArea.module.scss'

type MaxH = 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'none'
type MaxW = 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'none'

interface ScrollAreaProps {
  children: React.ReactNode
  maxH?: MaxH
  maxW?: MaxW
  horizontal?: boolean
  className?: never
}

const maxHMap: Record<MaxH, string> = {
  sm: styles.maxHSm, md: styles.maxHMd, lg: styles.maxHLg, xl: styles.maxHXl, full: styles.maxHFull, none: '',
}

const maxWMap: Record<MaxW, string> = {
  sm: styles.maxWSm, md: styles.maxWMd, lg: styles.maxWLg, xl: styles.maxWXl, full: styles.maxWFull, none: '',
}

export const ScrollArea: React.FC<ScrollAreaProps> = ({
  children, maxH = 'none', maxW = 'none', horizontal = false,
}) => (
  <div className={[horizontal ? styles.scrollX : styles.scrollY, maxHMap[maxH], maxWMap[maxW]].filter(Boolean).join(' ')}>
    {children}
  </div>
)
